interface FAQSchemaProps {
    questions: Array<{
        answer: string;
        question: string;
    }>;
}

export function FAQSchema({ questions }: FAQSchemaProps) {
    const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: questions.map((q) => ({
            "@type": "Question",
            acceptedAnswer: {
                "@type": "Answer",
                text: q.answer,
            },
            name: q.question,
        })),
    };

    return <script dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} type="application/ld+json" />;
}
